import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { TextField, Typography, Box } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import inputValidation from '../utils/globalValidation';

export default function CustomDate({
  name,
  label,
  control,
  errors,
  isRequired = false,
  disabled = false,
  fieldCode = 'DATE',
  fieldType = 'DATE_FIELD',
  minDate,
  maxDate,
  format = 'DD/MM/YYYY',
  ...props
}) {
  const [validationError, setValidationError] = useState('');
  const fieldError = errors?.[name];

  return (
    <Box>
      {label && (
        <Typography variant="h6" className="formLabel">
          {label} {isRequired && <span style={{ color: 'red' }}>*</span>}
        </Typography>
      )}

      <Controller
        name={name}
        control={control}
        rules={{
          ...(isRequired && { required: `${label || name} is required` }),
          validate: {
            validation: (value) => {
              const result = inputValidation({ target: { value } }, fieldCode, fieldType);
              return result === true || result;
            }
          }
        }}
        render={({ field: { onChange, value, onBlur } }) => {
          const handleChange = (newValue) => {
            const formattedValue = newValue ? dayjs(newValue).format('YYYY-MM-DD') : '';

            const validationResult = inputValidation(
              { target: { value: formattedValue } },
              fieldCode,
              fieldType
            );

            setValidationError(typeof validationResult === 'string' ? validationResult : '');

            if (validationResult === true || typeof validationResult === 'string') {
              onChange(formattedValue);
            }
          };

          return (
            <DatePicker
              value={value ? dayjs(value) : null}
              onChange={handleChange}
              inputFormat={format}
              disabled={disabled}
              minDate={minDate ? dayjs(minDate) : undefined}
              maxDate={maxDate ? dayjs(maxDate) : undefined}
              slotProps={{
                popper: {
                  sx: {
                    zIndex: 15000
                  }
                }
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  error={!!fieldError || !!validationError}
                  helperText={fieldError?.message || validationError}
                  inputProps={{
                    ...params.inputProps,
                    className: 'textInput'
                  }}
                  onBlur={onBlur}
                />
              )}
              {...props}
            />
          );
        }}
      />
    </Box>
  );
}
